module.exports = __webpack_public_path__ + "static/media/PoppinsBold.08c20a48.ttf";